import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSigns'
})
export class RemoveSignsPipe implements PipeTransform {

  transform(value: any): string {
    if (value === null || value === undefined) return '';
    return value.toString().replace(/[+-]/g, '');
  }

}
